<div class="member-details rounded bg-white border">
  <div class="member-details-header">
    <h3 class="member-details-title mb-0 font-page-heading">{{ 'membership.details.title' | translate: { fgbdefault: 'Membership' } }}</h3>
    <p class="member-details-subtitle mb-0">
      {{ 'membership.details.subtitle' | translate: { fgbdefault: 'Your membership details' } }}
    </p>
  </div>

  @if (subscribedProduct && subscribedProduct.ProductType == 1) {
  <div class="member-tier-card">
    <div class="member-tier-banner">
      <div class="member-tier-info-row">
        <div class="member-tier-badge">
          <img alt="" [src]="'icons/mvp-badge.png' | contentAssetImage" />
        </div>
        <div class="member-tier-info">
          <span class="member-tier-name">{{ currentSubscribedProduct.DisplayName }}</span>
          <span class="member-status-pill" [class.inactive]="!isActive">
            <span class="status-dot"></span>
            {{
              (isActive ? 'membership.details.status.active' : 'membership.details.status.inactive')
                | translate: { fgbdefault: isActive ? 'Active' : 'Inactive' }
            }}
          </span>
        </div>
      </div>
    </div>
  </div>

  } @else {
  <div class="member-tier-card">
    <div class="member-tier-banner member-tier-banner--standalone">
      <div class="member-tier-info-row">
        <div class="member-tier-badge">
          <img alt="" [src]="'icons/mvp-badge.png' | contentAssetImage"  />
        </div> 
        <div class="member-tier-info">
          <span class="member-tier-name">{{ 'membership.details.free.name' | translate: { fgbdefault: 'Free Ticket Member' } }}</span>
          <span class="member-status-pill">
            <span class="status-dot"></span>
            {{ 'membership.details.status.active' | translate: { fgbdefault: 'Active' } }}
          </span>
        </div>
      </div>
      <button
        type="button"
        class="member-upgrade-btn rounded"
        (click)="openUpgradeModal(upgradeModal)"
        [disabled]="!availableMembershipProducts?.length"
      >
        {{ 'membership.details.upgrade.plan' | translate: { fgbdefault: 'Upgrade Plan' } }}
      </button>
    </div>
  </div>
  }
</div>

<!--Upgrade plan modal-->
<ng-template #upgradeModal let-modal>
  <div class="text-black bg-white upgrade-plan-modal">
    <div class="modal-body">
      <a class="close-btn" (click)="modal.dismiss()">
        <i class="material-icons text-info">close</i>
      </a>
      @for (product of availableMembershipProducts; track product.ProductId) {
      <div class="upgrade-plan-card d-flex flex-column align-items-center">
        <div class="upgrade-plan-logo rounded">
          <img alt="" src="{{ product.PrimaryImage | contentImage: '6' }}" />
        </div>
        <div class="upgrade-plan-heading d-flex flex-column align-items-center">
          <span class="upgrade-plan-name font-page-heading">{{ product.DisplayName }}</span>
          <span class="upgrade-plan-price">{{ product.MerchantPrice / 100 | FortressCurrencyPipe: currencyCode }}</span>
        </div>
        <p class="upgrade-plan-description mb-0" [innerHTML]="product.Description"></p>
        <div class="upgrade-plan-confirm text-center">
          <p class="upgrade-plan-confirm-title mb-0">{{ 'subscription.modal.upgrade.label' | translate }}</p>
          <p class="upgrade-plan-confirm-text mb-0">{{ 'subscription.modal.upgrade.message' | translate }}</p>
        </div>
        <button type="button" class="upgrade-plan-btn rounded" (click)="upgradeToProduct(product, modal)">
          {{ 'subscription.modal.upgrade.button' | translate }}
        </button>
      </div>
      }
    </div>
  </div>
</ng-template>

<!--Product info modal-->
<ng-template #productInfo let-modal>
  <div class="text-black bg-white subscription-item-renewal-modal">
    <div class="modal-body d-flex flex-column align-items-center">
      <a class="close-btn ms-auto" (click)="modal.dismiss()">
        <i class="material-icons text-info">close</i>
      </a>
      <img
        alt=""
        class="info-product-image rounded my-2"
        src="{{ currentSubscribedProduct.PrimaryImageURL | contentImage: '6' }}"
      />
      <label class="font-size-14 mb-2">{{ currentSubscribedProduct.DisplayName }}</label>

      <p class="mb-4 mt-3 font-size-12 portal-product-modal-description" [innerHTML]="currentSubscribedProduct.Description"></p>
      <div class="text-center d-flex w-100 mt-3 justify-content-center">
        <div class="expiry-date-wrapper rounded" [class.expired]="withinRenewal">
          <span class="expiry-label font-size-12 fw-bold">{{
            (withinRenewal ? 'subscription.list.item.expired.label' : 'subscription.list.item.expiry.label') | translate
          }}</span>
          <span class="ms-2 expiry-date font-size-12"> {{ 'subscription.list.item.expired.date' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>
